<div class="container-fluid exam-correction-detail">
  <div class="row">
    <div class="col-12">
      <div class="user-list-cbt ace-list-page">
        <div class="user-list-header ace-list-header">
          <div class="bread-crumbs project-font">
            <span class="users-title ace-list-title">{{ 'Assessment Overview' | aceTranslate }}</span>
          </div>
          <div class="header-actions ace-list-actions">
            <app-button
              class="ace-header-back-button"
              buttonType="button"
              buttonMainStyle="normal-btn-border"
              [buttonText]="'Back' | aceTranslate"
              (btnClick)="goBack()">
            </app-button>
            <app-breadcrumb [items]="[
              { label: correctionsLabel, url: correctionsBasePath },
              { label: ('Assessment Overview' | aceTranslate) || assessment?.nameEn }
            ]"></app-breadcrumb>
          </div>
        </div>
      </div>

      <div *ngIf="loading" class="text-center py-4 project-font">
        {{ 'Loading...' | aceTranslate }}
      </div>

      <ng-container *ngIf="!loading">
        <section class="detail-shell mb-4" *ngIf="assessment">
          <!-- <div class="detail-shell__toolbar">
            <app-button
              buttonType="button"
              buttonMainStyle="detail-shell__back-btn"
              [buttonText]="'Back' | aceTranslate"
              (btnClick)="goBack()">
            </app-button>
          </div> -->

          <div class="detail-summary__metrics detail-summary__metrics--outside">
            <app-metric-cards [cards]="assessmentMetricCards"></app-metric-cards>
          </div>

          <!-- <div class="detail-shell__panel">
           
            <div class="detail-summary">
              <div class="detail-summary__content">
                <div class="detail-summary__intro">
                  <div class="detail-summary__eyebrow">{{ assessmentTypeLabel }}</div>
                  <h2 class="detail-summary__title">{{ assessmentDisplayName }}</h2>
                  <p *ngIf="!shouldUseNativeNames() && assessment.nameNative" class="detail-summary__native mb-0">{{ assessment.nameNative }}</p>
                  <p class="detail-summary__course mb-0">{{ assessmentCourseDisplayName }}</p>

                  <div class="detail-summary__meta">
                    <span>
                      <i class="ri-calendar-line"></i>
                      {{ 'Scheduled' | aceTranslate }}: {{ scheduledDisplay }}
                    </span>
                    <span>
                      <i class="ri-time-line"></i>
                      {{ 'Duration' | aceTranslate }}: {{ durationDisplay }}
                    </span>
                  </div>
                </div>

                <div class="detail-summary__aside">
                  <span [class]="roleBadgeClass(role)">
                    {{ roleLabel }}
                  </span>
                  <p class="detail-summary__role-copy mb-0">{{ roleDescription }}</p>
                </div>
              </div>

            </div>

          </div> -->
        </section>

        <section class="detail-shell__panel">
          <div class="detail-shell__panel-header detail-shell__panel-header--table">
            <div>
              <span class="detail-shell__panel-label">{{ 'Learner Submissions' | aceTranslate }}</span>
              <h3 class="detail-shell__panel-title mb-0">{{ 'Assigned Cases' | aceTranslate }}</h3>
              <p class="detail-shell__panel-copy mb-0">
                {{ 'Open a learner case to review answers, score responses, and submit your grading decision.' | aceTranslate }}
              </p>
            </div>

            <span class="detail-shell__count">{{ visibleLearners.length }}</span>
          </div>

          <app-tablev2
            *ngIf="visibleLearners.length; else noLearnersTpl"
            [tblHeader]="learnersTableHeader"
            [tblData]="learnersTableData"
            dataKey="resultId"
            tblToolbar="v"
            [rows]="10"
            [paginator]="learnersTableData.length > 10"
            [canRefresh]="false"
            [canExport]="true"
            [hasAdd]="false"
            (onViewClick)="openLearnerCase($event)">
          </app-tablev2>
        </section>

        <ng-template #noLearnersTpl>
          <div class="card corrections-empty-card">
            <div class="card-body text-center py-4">
              <div class="text-muted">{{ 'No learners need grading.' | aceTranslate }}</div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
